import * as React from "react";
import {
    Typography,
    Box,
    Button,
    CircularProgress,
    Autocomplete,
    MenuItem,
} from "@mui/material";
import { connect } from "react-redux";
import { notification } from "antd";
import {
    main_button,
    MainInput,
} from "../../app/components/Styles";
import { FoCard, FoChips } from "./financeUi";
import { brandFilterOptions, brandOptionLabel } from "../../app/components/BrandSelect";
import { useNavigate } from "react-router-dom";
import { addFees, getVendors } from "../../app/store/actions/whFinanceActions";

export const AddFees = ({
    addFees,
    getVendors,
    isLoading,
    vendors,
}) => {
    const [selectedVendor, setSelectedVendor] = React.useState(null);
    const [fees, setFees] = React.useState("");
    const [service, setService] = React.useState("");
    const [typeOfTransaction, setTypeOfTransaction] = React.useState("Fees");
    const [feeType, setFeeType] = React.useState("Inbound");
    const navigate = useNavigate();

    const feeTypeOptions = ["Inbound", "Outbound", "Overstock", "Transportation", "Order Pickup", "Repacking", "Other"];

    React.useEffect(() => {
        getVendors();
    }, [getVendors]);

    const handleSubmit = (event) => {
        event.preventDefault();
        
        if (!selectedVendor || !fees || !service) {
            notification.error({ message: "Please fill all fields" });
            return;
        }

        if (typeOfTransaction === "Fees" && !feeType) {
            notification.error({ message: "Please fill all fields" });
            return;
        }

        const data = {
            vendorId: selectedVendor._id,
            value: typeOfTransaction === "Fees" ? parseFloat(fees) : parseFloat(fees) * -1,
            service: service
        };

        // Only include feeType for Fees, not for Compensations
        if (typeOfTransaction === "Fees") {
            data.feeType = feeType;
        }

        addFees(data, navigate);
    };

    return (
        <FoCard className="fo-form" title={typeOfTransaction === "Fees" ? "Add a fee" : "Add a compensation"} note="Amount, brand, and service are saved on the fee ledger.">
                <Box
                    component="form"
                    onSubmit={handleSubmit}
                    sx={{ mt: 1 }}
                >
                    <Box sx={{ mb: 3 }}>
                        <FoChips
                            value={typeOfTransaction}
                            onChange={setTypeOfTransaction}
                            options={[
                                { value: "Fees", label: "Fee" },
                                { value: "Compenstation", label: "Compensation" },
                            ]}
                        />
                    </Box>
                    
                    <Box sx={{ mb: 3 }}>
                        <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: 'text.secondary' }}>
                            Select Vendor *
                        </Typography>
                        <Autocomplete
                            options={vendors || []}
                            value={selectedVendor}
                            onChange={(_, value) => setSelectedVendor(value)}
                            getOptionLabel={brandOptionLabel}
                            filterOptions={brandFilterOptions}
                            renderInput={(params) => (
                                <MainInput
                                    {...params}
                                    fullWidth
                                    placeholder="Select Vendor"
                                />
                            )}
                        />
                    </Box>

                    {typeOfTransaction === "Fees" && (
                        <Box sx={{ mb: 3 }}>
                            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: 'text.secondary' }}>
                                Fee Type *
                            </Typography>
                            <MainInput
                                fullWidth
                                value={feeType}
                                onChange={(e) => setFeeType(e.target.value)}
                                select
                            >
                                {feeTypeOptions.map((option) => (
                                    <MenuItem key={option} value={option}>
                                        {option}
                                    </MenuItem>
                                ))}
                            </MainInput>
                        </Box>
                    )}

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: 'text.secondary' }}>
                            {typeOfTransaction} Amount *
                        </Typography>
                        <MainInput
                            fullWidth
                            type="number"
                            value={fees}
                            onChange={(e) => setFees(e.target.value)}
                            placeholder="Enter amount"
                        />
                    </Box>

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: 'text.secondary' }}>
                            Service *
                        </Typography>
                        <MainInput
                            fullWidth
                            value={service}
                            onChange={(e) => setService(e.target.value)}
                            placeholder="Enter service"
                        />
                    </Box>

                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        sx={{ ...main_button, py: 1.5, mt: 2 }}
                        disabled={isLoading}
                    >
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : "Add Fees"}
                    </Button>
                </Box>
        </FoCard>
    );
};

const mapStateToProps = (state) => ({
    isLoading: state?.wait?.isLoading,
    vendors: state?.records?.vendors,
});

const mapDispatchToProps = { addFees, getVendors };

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddFees);
